import React from 'react';
import {ReactHint} from '../components/components';
import {MDCTabBarScroller,MDCTextInput,MDCCheckbox,MDCAnchorMenu,MDCMenu,MDCFileUpload,MDCSnackBar} from '../components/mdc-components';
//import ServiceContainer from '../../lib/service/container';
import ServiceFactory from '../service/factory';

export class MediaManagerFileType extends React.Component{
    getPdfDocUrl(){
      return 'data:image/png;base64,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';
    }

    getDocUrl(){
      return 'data:image/png;base64,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';
    }

    getVideoUrl(){
      return 'data:image/png;base64,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';
    }

    getUrl(item) {
      var type = this.getFileType(item);
      if (type === 'image') return (item.url) ? this.getWidthFormattedImageUrl(item.url) : item.dataUrl;
      else if (type === 'pdf') return this.getPdfDocUrl();
      else if (type==='mp4') return this.getVideoUrl();
      else return this.getDocUrl();
    }

    getFileType(file) {
      if (file.isImage) return 'image';
      else if (file.name.indexOf('.pdf') > -1) return 'pdf';
      else if(file.name.indexOf('.mp4') > -1) return 'mp4'; 
      else return 'doc';
    }

    getFileUrl(item) {
      return (item.url) ? item.url : item.dataUrl;
    }

    getWidthFormattedImageUrl(url){
      var width=this.queryStringWidth;
      if(width>0){
        if(url.indexOf('?') > -1) url+='&width=' + width;
        else url+='?width=' + width;
        return url;
      }else return url;
    }
}

export class MediaManagerToolbar extends React.Component{
   constructor(props){
       super(props);
   }

   onSearchIconClick(event){
       this.searchBar.classList.add('expanded');
       this.searchInput.focus();
   }

   onSearchCloseClick(event){
       this.searchBar.classList.remove('expanded');
       this.searchInput.blur();
   }

   onExit(event){
      this.props.onCancel();
   }

   onKeyPress(event){
      var code = event.keyCode ? event.keyCode : event.which; 
      if(code==13) {
          event.preventDefault();
          var value=this.searchInput.value;
          this.props.onSearch(value);
          this.searchInput.blur();
      }
   }

   onChange(event){
       if(event.target.value==='') this.props.onSearchRefresh();
   }

   onTabChange(index){
       this.props.onTabChange(index);
   }

   get activeTabIndex(){
       return this.tabs.activeTabIndex;
   }

   set activeTabIndex(index){
       this.tabs.activeTabIndex=index;
   }

   resetSearchValue(){
       this.searchInput.value='';
   }

    render(){
        if(!this.props.show) return null;
        var selectedLabel=this.props.selectedTabLabel;
        if(!selectedLabel) selectedLabel='Selected';
        var selectedTabCss='mdc-tab';
        if(this.props.mode==='browse') selectedTabCss+= ' hide';
        return(
            <header>
              <div className="nav-container">
                 <div className="tab-bar">
                   <MDCTabBarScroller onTabChange={this.onTabChange.bind(this)} ref={(ref) => this.tabs = ref}>
                       <a className="mdc-tab mdc-tab--active">Library</a>
                       <a className={selectedTabCss}>{selectedLabel}</a>
                       <a className="mdc-tab">Recently Added</a>
                       <a className="mdc-tab">Upload</a>
                       <a className="mdc-tab">Tags</a>
                   </MDCTabBarScroller>
                 </div>
                 <div className="search-bar" ref={(ref) => this.searchBar = ref}>
                      <i className="material-icons search-icon" onClick={this.onSearchIconClick.bind(this)}>search</i>
                      <input type="text" 
                        placeholder="Search media..." 
                        ref={(ref) => this.searchInput = ref} 
                        onKeyPress={this.onKeyPress.bind(this)}
                        onChange={this.onChange.bind(this)}
                       />
                      <i className="material-icons close-icon" onClick={this.onSearchCloseClick.bind(this)}>clear</i>
                 </div> 
               </div>  
               <div className="close-container">
                   <ReactHint events position="top" />
                   <i className="material-icons pointer" data-rh="Exit" onClick={this.onExit.bind(this)}>exit_to_app</i>
               </div>
            </header>
        );
    }
}

export class MediaManagerAsideImage extends MediaManagerFileType{

   render(){
       var file=this.props.file;
       return(
        <div className="camera-file-container">
              <div className="camera-file-inner-container">
                 <div className="camera-nested-inner-container">
                   {file.url ? (
                        <img src={this.getUrl(file)} />
                   ):(
                       <img />
                   )}
                 </div>
              </div>
          </div>
       );
   }
}

export class MediaManagerAsideSvg extends React.Component{
   render(){
       var file=this.props.file;
       return(
        <div>
            {!file.url && 
               <svg fill="#3899ec" height="64" width="64" viewBox="0 0 24 24" className="camera-icon">
                   <circle cx="12" cy="12" r="3.2"/>
                   <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
                   <path d="M0 0h24v24H0z" fill="none"/>
               </svg>
            }
        </div>
       );
   }
}

export class MediaManagerAsideCard extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        var file=this.props.file;
        var show=this.props.show;
        var css='paper-card hide';
        if(show) css='paper-card';
        
        return(
            <div className={css} ref={(ref) => this.element = ref}>
               <header>
                 <div>
                   <i className="material-icons">aspect_ratio</i>
                   <span>Image Info</span>
                 </div>
                 <i className="material-icons close" onClick={this.props.onLibraryInfoClose}>clear</i>
                </header>
                <section>
                  <div>Size:</div>
                  <div className="data">{file.size}</div>
                  <div>Width:</div>
                  <div className="data">{file.imageWidth}</div>
                  <div>Height:</div>
                  <div className="data">{file.imageHeight}</div>
                  <div className="accent-color bold">Tag:</div>
                  <div className="data bold">{file.tag}</div>
                </section>
            </div>
        );
    }
}

export class MediaManagerAsideScrollable extends React.Component{
    constructor(props){
        super(props);
    }

    componentDidMount() {
       this.scrollable.classList.remove('hidden');
    }

    onClipboardPaste(event){
       if(this.props.clipboardActive) this.props.onClipboardPaste();
    }

    onTextBlur(event){
        var file=this.props.file;
        var target=event.target;
        var prop=target.id;
        var value=target.value;
        file[prop]=value;
    }

    onTextEnter(event){
        var file=this.props.file;
        var target=event.target;
        var prop=target.id;
        var value=target.value;
        file[prop]=value;
    }

    onTargetChange(event){
        var file=this.props.file;
        var target=event.target;
        file.newTarget=target.checked;
    }

    render(){
        var file=this.props.file;
        var hiddenCss='';
        var lnkBoxCss='link-box';
        var targetBoxCss='target-box';
        var disabled=this.props.disabled;
        if(disabled){
            hiddenCss='hidden';
            lnkBoxCss='link-box hidden';
            targetBoxCss='target-box hidden';
        }
        var linkCss='material-icons link inactive';
        if(this.props.clipboardActive) linkCss='material-icons link';
        return(
            <div scrollable="true" className="hidden" ref={(ref) => this.scrollable = ref}>
               <MDCTextInput label="Title"  cls={hiddenCss} disabled={disabled}  value={file.title} 
                  id="title" 
                  onKeyEnter={this.onTextEnter.bind(this)}
                  onBlur={this.onTextBlur.bind(this)} 
                  ref={(ref) => this.title = ref} 
                />
               <MDCTextInput label="Meta" cls={hiddenCss} disabled={disabled} value={file.meta} 
                   id="meta" 
                   onKeyEnter={this.onTextEnter.bind(this)}
                   onBlur={this.onTextBlur.bind(this)} 
                   ref={(ref) => this.meta = ref} 
                />
               <div className={lnkBoxCss} id="linkBox">
                  <MDCTextInput label="Link" disabled={disabled} value={file.link} 
                     id="link" 
                     onKeyEnter={this.onTextEnter.bind(this)}
                     onBlur={this.onTextBlur.bind(this)} 
                     ref={(ref) => this.link = ref} 
                   />
                  <i className={linkCss} ref={(ref) => this.iconLink = ref} onClick={this.onClipboardPaste.bind(this)}>link</i>
               </div>
               <div className={targetBoxCss} id="targetBox">
                 <span>New Tab</span>
                 <MDCCheckbox disabled={disabled} checked={file.newTarget} onCheckedChange={this.onTargetChange.bind(this)} />
               </div>
                <MDCTextInput label="Width" cls={hiddenCss} disabled={disabled} value={file.width} 
                   id="width" 
                   onKeyEnter={this.onTextEnter.bind(this)}
                   onBlur={this.onTextBlur.bind(this)} 
                   ref={(ref) => this.width = ref} 
                 />
                <div className="library-info-box">
                    <h4>Library Info</h4>
                    <div>
                       <span>Size:</span>
                       <span>{file.size}</span>
                    </div>
                    <div>
                       <span>Width:</span>
                       <span>{file.imageWidth}</span>
                    </div>
                    <div>
                        <span>Height:</span>
                        <span>{file.imageHeight}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export class MediaManagerAside extends React.Component{
   constructor(props){
       super(props);
   }

   render(){
      var file=this.props.file;
      if(!file) file={}; 
      var name=file.name;
      if(!name) name='File Info';

      return(
        <aside>
            <div className="camera-container">
                <MediaManagerAsideCard 
                  show={this.props.showCard} 
                  file={file} 
                  onLibraryInfoClose={this.props.onLibraryInfoClose} 
                />
                <MediaManagerAsideSvg file={file} />
                <MediaManagerAsideImage file={file} />
            </div>
            <header className="header-info">
                <h6 id="imageInfo">{name}</h6>
            </header>
            <section>
                <MediaManagerAsideScrollable 
                  file={file} 
                  clipboardActive={this.props.clipboardActive} 
                  onClipboardPaste={this.props.onClipboardPaste} 
                />
            </section>  
         </aside>
      );
   }
}

export class MediaManagerFooter extends React.Component{
   constructor(props){
       super(props);
   }

   onCancel(event){
       this.props.onCancel();
   }

   onDone(event){
       this.props.onDone();
   }

   render(){
      return(
        <footer>
              <button className="ink dark no-elevation" onClick={this.onCancel.bind(this)}>
                  Cancel
              </button>
              <button className="ink dark no-elevation" onClick={this.onDone.bind(this)}>
                  Done
              </button>
         </footer>
      );
   }
}

export class MediaManagerMainHeader extends React.Component{
   constructor(props){
       super(props);
   }

   onMenuSelected(event){
       this.props.onSelectedTag(event.detail.item.dataset);
   }

   render(){
      var mode=this.props.mode; 
      var tag=this.props.tag;
      var tags=this.props.tags;
      if(!tags || !tags.length){
        tags=[];
      }
      var items = tags.map((tag)=> {
          return (
            <li key={tag.id} className="mdc-list-item" role="menuitem" tabIndex="0" data-value={tag.name} data-id={tag.id}>{tag.name}</li>
          );
      });
      return(
        <header className="main-header">
           <div className="label-total flex-box align-center">
             <i className="material-icons">bookmark_border</i>
             <div><span className="tag">{tag}</span></div>
             <div className="size-14 margin-left hide-touch"><span className="secondary-color">Mode: </span><span>{mode}</span></div>
           </div>
           <div>
               <MDCAnchorMenu menuId="tagsMenu" onMenuSelected={this.onMenuSelected.bind(this)}>
                  <button className="accent-button ink" data-anchor><i className="material-icons">bookmark_border</i> Tags</button>
                  <MDCMenu disableInit="true" id="tagsMenu">
                    {items}
                  </MDCMenu>
               </MDCAnchorMenu>
           </div>
         </header>
      );
   }
}

export class MediaManagerFile extends MediaManagerFileType{
   constructor(props){
       super(props);
       this.file=this.props.file;
       this.queryStringWidth=this.props.queryStringWidth;
       this.active=false;
   }

   onLibraryClipboard(event){
    if(this.props.onLibraryClipboard) this.props.onLibraryClipboard(this.file);
   }

   onLibraryInfo(event){
    if(this.props.onLibraryInfo) this.props.onLibraryInfo(this.file);
   }

   onLibraryDelete(event){
     if(this.props.onLibraryDelete) this.props.onLibraryDelete(this.file);
   }

   onLibraryRemove(event){
    if(this.props.onLibraryRemove) this.props.onLibraryRemove(this.file);
   }

   onFileClick(event){
     if(this.file.active && this.props.onFileUnSelect){
         this.file.active=false;
         this.props.onFileUnSelect(this.file);
     }else if(this.props.onFileSelect){
         this.file.active=true;
         this.props.onFileSelect(this.file);
     }
   }

   render(){
      var file=this.props.file;
      var fileContainerCss='file-container';
      if(file.active) fileContainerCss+= ' active';
      var showRemove=this.props.showRemove;
      return(
        <div className="file-outer-container" data-id={file.id}>
          <div className={fileContainerCss}>
            <div className="file-inner-container" onClick={this.onFileClick.bind(this)}>
              <div className="file-nested-inner-container">
                <img src={this.getUrl(file)} />
              </div>
            </div>
            <div className="hover-container">
              <i className="material-icons" onClick={this.onLibraryClipboard.bind(this)}>content_copy</i>
              <i className="material-icons" onClick={this.onLibraryInfo.bind(this)}>info</i>
              {showRemove ? (
                   <i className="material-icons" onClick={this.onLibraryRemove.bind(this)}>remove</i>
              ):(
                <i className="material-icons" onClick={this.onLibraryDelete.bind(this)}>delete</i>
              )}
            </div>
          </div>
          <div className="file-name">{file.name}</div>
        </div>
      );
   }
}

export class MediaManagerLibrary extends React.Component{
   constructor(props){
       super(props);
   }

   onNextPage(event){
       var page=this.props.page + 1;
       this.props.onNextPage(page);
   }

   onPrevPage(event){
       var page=this.props.page - 1;
       this.props.onPrevPage(page);
   }

   render(){ 
      if(this.props.selectedTab!=='library') return null;
      var pageCount=parseInt(this.props.pageCount);
      var page=parseInt(this.props.page);
      var backArrowCss='material-icons';
      var forwardArrowCss='material-icons';
      var refreshCss='material-icons icon margin-right';
      if(page < pageCount) forwardArrowCss+=' nav large-margin-right';
      else forwardArrowCss+= ' hidden';
      if(page > 1) backArrowCss += ' nav margin-right half';
      else backArrowCss += ' hidden';
      var filesCount=this.props.filesCount;
      var filesCountLabel='';
      if(filesCount===1) filesCountLabel='1 file';
      else filesCountLabel= filesCount.toString() + ' files';
      var files = this.props.files.map((file)=> {
          return (
              <MediaManagerFile file={file} key={file.id} 
                onFileSelect={this.props.onFileSelect.bind(this)}  
                onFileUnSelect={this.props.onFileUnSelect.bind(this)} 
                onLibraryClipboard={this.props.onLibraryClipboard.bind(this)} 
                onLibraryInfo={this.props.onLibraryInfo.bind(this)} 
                onLibraryDelete={this.props.onLibraryDelete.bind(this)} 
                queryStringWidth={this.props.queryStringWidth} 
               />
          );
      });
      var count=files.length;
      
      return(
        <div>
            <header>
              <h4 className="accent-color">{filesCountLabel}</h4>
              <div className="flex-box align-center">
                <div className="relative">
                  <ReactHint events position="top" />
                  <i className={refreshCss} data-rh="Refresh" onClick={this.props.onRefresh.bind(this)}>refresh</i>
                </div>
                <div className="navigation-arrows">
                  <i className={backArrowCss} onClick={this.onPrevPage.bind(this)}>arrow_back</i>
                  <i className={forwardArrowCss} onClick={this.onNextPage.bind(this)}>arrow_forward</i>
                </div>
              </div>
            </header>
             <div className="flex-library">
             {count>0 ? (
                   files
              ):(
                  <div>No files available...</div>
              )}
            </div>
        </div>
      );
   }
}

export class MediaManagerAdded extends React.Component{
   constructor(props){
       super(props);
   }

   render(){
      if(this.props.selectedTab!=='added') return null;
      var files=this.props.files;
      var count=files.length;
      var filesCountLabel='';
      if(count===1) filesCountLabel='1 file';
      else filesCountLabel= count.toString() + ' files';
      var addedFiles = this.props.files.map((file)=> {
          return (
              <MediaManagerFile file={file} key={file.id} 
                 onFileSelect={this.props.onFileSelect.bind(this)}  
                 onFileUnSelect={this.props.onFileUnSelect.bind(this)} 
                 onLibraryClipboard={this.props.onLibraryClipboard.bind(this)} 
                 onLibraryInfo={this.props.onLibraryInfo.bind(this)} 
                 onLibraryDelete={this.props.onLibraryDelete.bind(this)} 
                 queryStringWidth={this.props.queryStringWidth} 
              />
          );
      });
      
      return(
        <div>
            <header>
              <h4 className="accent-color">{filesCountLabel}</h4>
            </header>
             <div className="flex-library">
             {count>0 ? (
                   addedFiles
              ):(
                  <div>No recently added files available...</div>
              )}
            </div>
        </div>
      );
   }
}

export class MediaManagerSelected extends React.Component{
   constructor(props){
       super(props);
   }

   componentDidUpdate() {
      var files=this.props.files;
      var count=files.length;
      if(!this.sortable && count > 1 && this.container) {
          this.sortable = Sortable.create(this.container,{draggable:'.file-outer-container',
          onEnd: (evt)=>{
              var oldIndex=evt.oldIndex;
              var newIndex=evt.newIndex;
              this.props.onSelectedSorted(oldIndex,newIndex);
          }
        });
      }
   }

   render(){
      if(this.props.selectedTab!=='selected'){
        if(this.sortable){
           this.sortable.destroy(); 
           this.sortable=null;  
        }
        return null;
      } 
      var files=this.props.files;
      var count=files.length;
      var filesCountLabel='';
      if(count===1) filesCountLabel='1 file';
      else filesCountLabel= count.toString() + ' files';
      var selectedFiles = this.props.files.map((file)=> {
          return (
              <MediaManagerFile file={file} key={file.id} 
                showRemove="true" 
                onFileSelect={this.props.onFileSelect.bind(this)}  
                onLibraryClipboard={this.props.onLibraryClipboard.bind(this)} 
                onLibraryInfo={this.props.onLibraryInfo.bind(this)} 
                onLibraryRemove={this.props.onLibraryRemove.bind(this)} 
                queryStringWidth={this.props.queryStringWidth} 
              />
          );
      });

      return(
        <div>
            <header>
              <h4 className="accent-color">{filesCountLabel}</h4>
            </header>
             <div className="flex-library" ref={(ref) => this.container = ref}>
             {count>0 ? (
                   selectedFiles
              ):(
                  <div>No selected files are available...</div>
              )}
            </div>
        </div>
      );
   }
}

export class MediaManagerUpload extends React.Component{
   constructor(props){
       super(props);
   }
 
   render(){
      if(this.props.selectedTab!=='upload') return null;
      var tag=this.props.selectedTag; 
      var lTag='';
      if (tag) lTag = tag.toLowerCase();     
      
      return(
        <div>
            <header>
              <h4 className="accent-color">File Upload</h4>
            </header>
            {lTag==='all' ? (
                 <div>
                   <p>Please select a tag other than <span className="secondary-color">All</span> to associate with the file upload...</p>
                 </div>
            ):(
                <div>
                   <p>
                   Select or drag files to add to your media library. The uploaded file(s) will be associated with 
                   tag: <span className="secondary-color">{tag}</span>
                   </p>
                   <MDCFileUpload postUrl={this.props.postUrl} tag={tag} onUploadComplete={this.props.onFileUploaded} />
                </div>
            )}
        </div>
      );
   }
}

export class MediaManagerTags extends React.Component{
   constructor(props){
       super(props);
   }

   componentDidUpdate() {
      if(this.input) this.input.value='';
      if(this.input) this.input.blur();
   }

   onKeyEnter(event){
       if(this.props.onAddMediaTag) this.props.onAddMediaTag(event);
   }

   render(){
      if(this.props.selectedTab!=='tags') return null; 
      var showMsg=false;
      var msg='';
      var msgCss='';
      if(this.props.showSuccess){
          showMsg=true;
          msgCss='success-color';
          msg='Tag added successfully...';
      }else if(this.props.showError){
          showMsg=true;
          msgCss='error-color';
          msg='Error adding tag...';
      }
      return(
        <div>
            <header>
              <h4 className="accent-color">Add New Tag</h4>
            </header>
            <div className="input-container">
               <MDCTextInput label="Add New Tag" onKeyEnter={this.onKeyEnter.bind(this)} ref={(ref) => this.input = ref}   />
            </div>
            {showMsg && 
               <div>
                   <span className={msgCss}>{msg}</span>
               </div>
            }
        </div>
      );
   }
}

export class MediaManager extends React.Component{
    constructor(props){
        super(props);
        var data=this.props.data;
        if(!data) data={};
        var mode=this.props.mode;
        if(!mode) mode='browse';
        var show=false;
        if(this.props.show) show=true;
        var tag=data.tag;
        var tags=data.tags;
        var files=data.files;
        var filesCount=data.count;
        var pageCount=data.pageCount;

        if(!files){
            files=[];
            filesCount=0;
            pageCount=1;
        }
        var state={
            files:files,
            addedFiles:[],
            selectedFiles:[],
            selectedFile:{},
            clipboardActive:false,
            showCard:false,
            tags:tags,
            filesCount:filesCount,
            pageCount:pageCount,
            page:1,
            selectedTag:tag,
            selectedTab:'library',
            show:show,
            mode:mode,
            kludge:''
        };
        this.state = { manager: state};
        this.showTagSuccess=false;
        this.showTagError=false;
        this.clipboard=null;
        this.searchValue=null;
        this.showLibraryTab=false;
    }

    /**
     * next page file query request; will pass along the current search input value
     * @param {int} page 
     */
    onNextPage(page){
        var value=this.searchValue;
        if(this.props.onFileQuery) this.props.onFileQuery(page,this.state.manager.selectedTag,value);
    }

    /**
    * previous page file query request; will pass along the current search input value
    * @param {int} page 
    */
    onPrevPage(page){
        var value=this.searchValue;
        if(this.props.onFileQuery) this.props.onFileQuery(page,this.state.manager.selectedTag,value);
    }

    /**
     *  refresh the files with a new query by selected tag, resetting the search value, if currently set
     */
    onRefresh(){
      this.searchValue=null;  
      this.toolbar.resetSearchValue();
      if(this.props.onFileQuery) this.props.onFileQuery(1,this.state.manager.selectedTag,null);
    }

    /**
     * new search, by new search value and the currently selected tag
     * @param {string} value 
     */
    onSearch(value){
      this.searchValue=value;
      this.toolbar.activeTabIndex=0;
      this.showLibraryTab=true;  
      if(this.props.onFileQuery) this.props.onFileQuery(1,this.state.manager.selectedTag,value);
    }

    /**
     * selected tab change
     * @param {int} index 
     */
    onTabChange(index){
      var selectedTab='library';
      switch(index){
          case 0:
            selectedTab='library';
            break;
          case 1:
            selectedTab='selected';
            break;
          case 2:
            selectedTab='added';
            break;
          case 3:
            selectedTab='upload';
            break;
          case 4:
            this.showTagSuccess=false;
            this.showTagError=false;
            selectedTab='tags';
            break;
      }
      this.state.manager.selectedTab=selectedTab;
      this.setState(this.state.manager);
    }

    /**
     * updates the selectedTag with the new selected tag; fires off a new files query
     * @param {object} detail 
     */
    onSelectedTag(detail){
       var tag=detail.value;
       this.state.manager.selectedTag=tag;
       this.setState(this.state.manager);
       this.onRefresh();
    }
    
    /**
     *  exit/cancel the manager
     */
    onCancel(){
       if(this.props.onCancel)this.props.onCancel();
       this.hide();
    }

    /**
     *  exit the manager and pass off the selectedFiles
     */
    onDone(){
       if(this.props.onFilesSelected)this.props.onFilesSelected(this.state.manager.selectedFiles);
       this.hide();
    }

    /**
     * replace selectedFile state prop with new selected file
     * if select mode(one selection at a time only), we also need to reset the active state of the old selected file and reset the selectedFiles array
     * if multi-select mode(more than one selection allowed), 
     * we do not need to bother with the active state of previously selected files; simply add the new to the selectedFiles array
     * @param {object} file 
     */
    onFileSelect(file){
        var selectedFiles=this.state.manager.selectedFiles.slice(0);
        if(this.state.manager.mode!=='multi-select'){
           var selectedFile=this.state.manager.selectedFile;
           //if currently selected file !== new selected file
           if(selectedFile.id && file.id !==selectedFile.id){
               var selectedLibraryFile=this.arrayFindItemById(this.state.manager.files,selectedFile.id);
               if(selectedLibraryFile) selectedLibraryFile.active=false;
           }
        }
        this.state.manager.selectedFile=file;
        if(this.state.manager.mode==='select') this.state.manager.selectedFiles=[file];
        else if(this.state.manager.mode==='multi-select'){
            selectedFiles.push(file);
            this.state.manager.selectedFiles=selectedFiles;
        }
        //update state to trigger re-render
        this.setState(this.state.manager);
    }
    
    /**
     * remove file from selectedFile state prop and selectedFiles array state prop
     * @param {object} file 
     */
    onFileUnSelect(file){
        this.state.manager.selectedFile={};
        if(this.state.manager.mode==='select') this.state.manager.selectedFiles=[];
        else if(this.state.manager.mode==='multi-select'){
            var selectedFiles= this.state.manager.selectedFiles.slice(0);
            this.state.manager.selectedFiles=this.arrayDeleteItemById(selectedFiles,file.id);
        }
        this.setState(this.state.manager);
    }
    
    /**
     *  selection of a file from library selections component
     * @param {obj} file 
     */
    onSelectedFileSelect(file){
        this.state.manager.selectedFile=file;
        this.setState(this.state.manager);
    }
    
    /**
     * sort selectedFiles array state from old and new indices to match sort from drag and drop sortable
     * @param {int} oldIndex 
     * @param {int} newIndex 
     */
    onSelectedSorted(oldIndex,newIndex){
        var selectedFiles=this.state.manager.selectedFiles.slice(0);
        var oldFile=selectedFiles[oldIndex];
        var newFile=selectedFiles[newIndex];
        selectedFiles[oldIndex]=newFile;
        selectedFiles[newIndex]=oldFile;
        this.state.manager.selectedFiles=selectedFiles;
        this.setState(this.state.manager);
    }
    
    /**
     *  on new media tag submit handler
     * @param {obj} event 
     */
    onAddMediaTag(event){
        var value=event.target.value;
        //this.showTagSuccess=true;
        //this.state.manager.selectedTag=value;
        //this.setState(this.state.manager);
        if(this.props.onAddMediaTag) this.props.onAddMediaTag(value);
    }
    
    /**
     * add copied file to the clipboard
     * @param {object} file 
     */
    onLibraryClipboard(file){
        this.clipboard=file;
        this.state.manager.clipboardActive=true;
        this.setState(this.state.manager);
    }

    /**
     * paste: update selectedFile link prop with clipboard file url prop
     * @param {object} file 
     */
    onClipboardPaste(file){
        if(this.state.manager.selectedFile.id){
           this.state.manager.selectedFile.link=this.clipboard.url; 
           this.state.manager.clipboardActive=false;
           this.clipboard=null;
           this.setState(this.state.manager);
        }
    }

    /**
    *  show the selectedFile info paper card
    * @param {object} file 
    */  
    onLibraryInfo(file){
        this.state.manager.selectedFile=file;
        this.state.manager.showCard=true;
        this.setState(this.state.manager);
    }
    
    /**
     * hides the info paper card
     */
    onLibraryInfoClose(){
        this.state.manager.showCard=false;
        this.setState(this.state.manager);
    }

    /**
     *  delete the file from the library
     * @param {object} file 
     */
    onLibraryDelete(file){
        if(this.props.onFileDelete) this.props.onFileDelete(file);
    }

    /**
     * remove file from selectedFiles, revert the file state in files to active=false
     * @param {object} file 
     */
    onLibraryRemove(file){
        var selectedFiles= this.state.manager.selectedFiles.slice(0);
        this.state.manager.selectedFiles=this.arrayDeleteItemById(selectedFiles,file.id);
        var selectedFile=this.state.manager.selectedFile;
        if(selectedFile.id===file.id)this.state.manager.selectedFile={};
        var files=this.state.manager.files.slice(0);
        var index=this.arrayFindIndexById(files,file.id);
        if(files[index]) files[index].active=false;
        this.state.manager.files=files;
        this.setState(this.state.manager);
    }

    /**
     * uploaded file handler; push to addedFiles state
     * @param {object} file 
     */
    onFileAdded(file){
        var addedFiles=this.state.manager.addedFiles.slice(0);
        addedFiles.push(file);
        this.state.manager.addedFiles=addedFiles;
        this.setState(this.state.manager); 
    }

    /** 
     *  tag add error handler
    */
    onTagAddedError(){
       this.showTagError=true;
       this.forceRerender();
    }

    /** 
     *  query error handler
     *  @param {string} msg
    */
    onQueryError(msg){
        this.snackbar.show(msg);
    }
    
    /**
     *  close media manager
     */
    hide(){
        this.state.manager.show=false;
        this.setState(this.state.manager);
    }

    /**
     *  show media manager
     *  @param {array} files
     */
    show(files){
        this.state.manager.show=true;
        if(files && files.length) this.state.manager.selectedFiles=files;
        this.setState(this.state.manager);
    }

    /**
     * set state with added new tag
     * @param {object} tag
     */
    setStateWithTagAdded(tag){
       this.showTagSuccess=true;
       this.state.manager.selectedTag=tag.name;
       var tags=this.state.manager.tags.splice(0);
       tags.push(tag);
       this.state.manager.tags=tags;
       this.setState(this.state.manager);
    }
    
    /**
     * set the state with a new files query result. Must ensure that any file in the new files query that matches a file currently in selectedFiles
     * is swapped out
     * @param {array} files
     * @param {object} tag 
     * @param {int} page
     */
    setStateWithFilesQuery(files,count,pageCount,tag,page){
        var selectedFiles=this.state.manager.selectedFiles.slice(0);
        var newFiles=[];
        files.forEach((file)=>{
            var match= this.arrayFindItemById(selectedFiles,file.id);
            if(match && match.id) newFiles.push(match);
            else newFiles.push(file);
        });
        this.state.manager.files=newFiles;
        this.state.manager.page=page;
        this.state.manager.selectedTag=tag;
        this.state.manager.filesCount=count;
        this.state.manager.pageCount=pageCount;
        if(this.showLibraryTab){
            this.state.manager.selectedTab='library';
            this.showLibraryTab=false;
        }
        this.setState(this.state.manager);
    }

    /**
     * set the state from the deleted file. Must ensure deletion from selectedFile or selectedFiles, if applicable
     * @param {object} file 
     */
    setStateWithFileDeleted(file){
       var selectedFile=this.state.manager.selectedFile;
       if(selectedFile.id===file.id) this.state.manager.selectedFile={};
       var selectedFiles= this.state.manager.selectedFiles.slice(0);
       var addedFiles=this.state.manager.addedFiles.slice(0);
       var files=this.state.manager.files.slice(0);
       selectedFiles=this.arrayDeleteItemById(selectedFiles,file.id);
       addedFiles=this.arrayDeleteItemById(addedFiles,file.id);
       files=this.arrayDeleteItemById(files,file.id);
       var filesCount=this.state.manager.filesCount;
       filesCount-=1;
       this.state.manager.selectedFiles=selectedFiles;
       this.state.manager.addedFiles=addedFiles;
       this.state.manager.files=files;
       this.state.manager.filesCount=filesCount;
       this.setState(this.state.manager);
    }

    /**
     *  force component re-render by setting a kludge prop
     */
    forceRerender(){
        this.state.manager.kludge=this.randomString();
        this.setState(this.state.manager);
    }

    /**
     * set the manager mode
     * @param {string} mode 
     */
    set mode(mode){
       this.state.manager.selectedFiles=[];
       this.state.manager.files=this.resetFiles();
       this.state.manager.selectedFile={};
       this.state.manager.mode=mode;
       this.state.manager.kludge=this.randomString();
       this.setState(this.state.manager);
    }
    
    /**
     *  reset all active files
     */
    resetFiles(){
        var files=this.state.manager.files.slice(0);
        files.forEach((file)=>{
            file.active=false;
        });
        return files;
    }

    /**
     * array utility, find item by id
     * @param {array} arr 
     * @param {string} id 
     */
    arrayFindItemById(arr,id){
        var length=arr.length;
        var result=null;
        for(var i=0;i<length;i++){
            if(arr[i]['id']===id){
                result=arr[i];
                break;
            }
        }
        return result;
    }

    /**
     * array utility, find index of item by id
     * @param {array} arr 
     * @param {string} id 
     */
    arrayFindIndexById(arr,id){
        var index=-1;
        var len=arr.length;
        for(var i=0;i<len;i++){
            if(arr[i]['id']===id){
                index=i;
                break;
            }
        }
        return index; 
    }

    /**
     * array utility, update existing item in array
     * @param {array} arr 
     * @param {object} item 
     */
    arrayUpdateItem(arr,item){
        var clone=arr.slice(0);
        var index=this.arrayFindIndexById(item.id);
        clone[index]=element;
        return clone;
    }

    /**
     * array utility, delete item in array by id
     * @param {array} arr 
     * @param {string} id 
     */
    arrayDeleteItemById(arr,id){
        var clone=arr.slice(0);
        var index=this.arrayFindIndexById(clone,id);
        if(index>-1){
            clone.splice(index,1);
        }
        return clone;
    }
    
    /**
     * array utility, add item to array
     * @param {array} arr 
     * @param {object} item 
     */
    arrayAddItem(arr,item){
        var clone=arr.slice(0);
        clone.push(item);
        return clone;
    }

    /**
     *  generates a random string
     */
    randomString(){
        let length=16;
        let chars = '0123456789';
        let result = '';
        for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    }

    render(){
        var containerCss='media-manager-container';
        if(!this.state.manager.show){
            containerCss+= ' hide';
        }
        const AsideComponent = this.props.AsideComponent || MediaManagerAside;
        return(
             <div className={containerCss}>
                 <div className="media-manager-background"></div>
                 <MDCSnackBar ref={(ref) => this.snackbar = ref}  />
                 <div className="media-manager">
                    <MediaManagerToolbar 
                      onSearch={this.onSearch.bind(this)} 
                      onTabChange={this.onTabChange.bind(this)} 
                      onSearchRefresh={this.onRefresh.bind(this)}
                      mode={this.state.manager.mode} 
                      show={this.state.manager.show}
                      onCancel={this.onCancel.bind(this)}
                      ref={(ref) => this.toolbar = ref} 
                    />
                     <section>
                         <div className="main-container">
                            <MediaManagerMainHeader 
                               mode={this.state.manager.mode} 
                               tag={this.state.manager.selectedTag}
                               tags={this.state.manager.tags} 
                               onSelectedTag={this.onSelectedTag.bind(this)} 
                             /> 
                             <section>
                                <MediaManagerLibrary 
                                  selectedTab={this.state.manager.selectedTab} 
                                  files={this.state.manager.files} 
                                  filesCount ={this.state.manager.filesCount} 
                                  page={this.state.manager.page} 
                                  pageCount = {this.state.manager.pageCount} 
                                  onNextPage={this.onNextPage.bind(this)} 
                                  onPrevPage={this.onPrevPage.bind(this)} 
                                  onRefresh={this.onRefresh.bind(this)} 
                                  onFileSelect={this.onFileSelect.bind(this)} 
                                  onFileUnSelect={this.onFileUnSelect.bind(this)} 
                                  onLibraryClipboard={this.onLibraryClipboard.bind(this)} 
                                  onLibraryInfo={this.onLibraryInfo.bind(this)} 
                                  onLibraryDelete={this.onLibraryDelete.bind(this)}
                                  queryStringWidth={this.props.queryStringWidth} 
                                />
                                <MediaManagerAdded 
                                  selectedTab={this.state.manager.selectedTab} 
                                  files={this.state.manager.addedFiles} 
                                  onFileSelect={this.onFileSelect.bind(this)} 
                                  onFileUnSelect={this.onFileUnSelect.bind(this)} 
                                  onLibraryClipboard={this.onLibraryClipboard.bind(this)} 
                                  onLibraryInfo={this.onLibraryInfo.bind(this)} 
                                  onLibraryDelete={this.onLibraryDelete.bind(this)} 
                                  queryStringWidth={this.props.queryStringWidth} 
                                />
                                <MediaManagerSelected 
                                  selectedTab={this.state.manager.selectedTab} 
                                  files={this.state.manager.selectedFiles} 
                                  onFileSelect={this.onSelectedFileSelect.bind(this)}
                                  onSelectedSorted={this.onSelectedSorted.bind(this)} 
                                  onLibraryClipboard={this.onLibraryClipboard.bind(this)} 
                                  onLibraryInfo={this.onLibraryInfo.bind(this)} 
                                  onLibraryRemove={this.onLibraryRemove.bind(this)} 
                                  showRemove="true" 
                                  queryStringWidth={this.props.queryStringWidth} 
                                />
                                <MediaManagerUpload 
                                   selectedTab={this.state.manager.selectedTab} 
                                   selectedTag={this.state.manager.selectedTag}
                                   postUrl={this.props.postUrl} 
                                   onFileUploaded={this.onFileAdded.bind(this)}
                                />
                                <MediaManagerTags 
                                   selectedTab={this.state.manager.selectedTab} 
                                   onAddMediaTag={this.onAddMediaTag.bind(this)}
                                   showSuccess={this.showTagSuccess} 
                                   showError={this.showTagError} 
                                   selectedTag={this.state.manager.selectedTag}
                                />
                             </section>
                         </div>
                         <AsideComponent
                           file={this.state.manager.selectedFile} 
                           showCard={this.state.manager.showCard} 
                           clipboardActive={this.state.manager.clipboardActive} 
                           onLibraryInfoClose={this.onLibraryInfoClose.bind(this)} 
                           onClipboardPaste={this.onClipboardPaste.bind(this)} 
                           onRemoveSelectedFile={this.onLibraryRemove.bind(this)} 
                           {...(this.props.asideProps || {})}
                          />
                     </section>
                     <MediaManagerFooter 
                        onCancel={this.onCancel.bind(this)} 
                        onDone={this.onDone.bind(this)}  
                      />
                 </div>
             </div>
        );
    }
}

export class MediaManagerController extends React.Component{
     constructor(props){
         super(props);
         this.pageSize=this.props.pageSize;
         if(!this.pageSize) this.pageSize=36;
         else this.pageSize=parseInt(this.pageSize);
         this.queryStringWidth=300;
     }

     componentDidMount() {
         if(!this.props.disableInitService) this._initServices();
     }

     onAddMediaTag(tag){
         var newTag={id:null,name:tag};
         this.TagService.post(newTag,(err,data)=>{
              if(!err) this.mediaManager.setStateWithTagAdded(data);
              else this.mediaManager.onTagAddedError();
         });
     }

     onFileQuery(page,tag,searchValue){
        if(searchValue && searchValue !=='') this._fileSearchQuery(page,tag,searchValue);
        else this._fileQuery(page,tag); 
     }

     onFileDelete(file,tag){
        this.FileService.delete({id:file.id},(err,data)=>{
             if(!err) this.mediaManager.setStateWithFileDeleted(file);
             else this.mediaManager.onQueryError('Error deleting file');
        });
     }

     onFilesSelected(files){
        console.log(this.props.onFilesSelected);
         if(this.props.onFilesSelected) this.props.onFilesSelected(files);
     }

     removeSelectedFile=(file)=>{
         this.mediaManager.onLibraryRemove(file);
     }

     /**
      * set the manager mode
      * @param {string} mode 
      */
     set mode(mode){
         this.mediaManager.mode=mode;
      }

     show(files){
        this.mediaManager.show(files);
     }

     _initServices(){
        var TagService=ServiceFactory.getType('MediaTag');
        var FileService = ServiceFactory.getType('MediaFile');
        this.TagService = new TagService();
        this.FileService =new FileService();
    
     }

     _fileSearchQuery(page,tag,value){
         var FileService = ServiceFactory.getType(`MediaFile/${tag}?$where=Name.ToLower().StartsWith(@0)&$params=${value}`);
         var service=new FileService();
         var baseUrl='';
         var rawUrl='';
         var pageSize=this.pageSize; 
         service.paginate({baseUrl, rawUrl, page, pageSize})
                .get({},(err,result)=>{
                    if(!err) this.mediaManager.setStateWithFilesQuery(result.items,result.pagination.count,result.pagination.pageCount,tag,page);
                    else this.mediaManager.onQueryError('Query error navigating page');
                });
     }

     _fileQuery(page,tag){
         var service=this.FileService;
         var baseUrl='';
         var rawUrl='';
         var pageSize=this.pageSize; 
         service.paginate({baseUrl, rawUrl, page, pageSize})
                .get({id:tag},(err,result)=>{
                    if(!err) this.mediaManager.setStateWithFilesQuery(result.items,result.pagination.count,result.pagination.pageCount,tag,page);
                    else this.mediaManager.onQueryError('Query error navigating page');
                });
     }

     render(){
         return(
             <MediaManager 
               ref={(ref) => this.mediaManager = ref}
               data={this.props.data} 
               postUrl={this.props.postUrl} 
               mode={this.props.mode} 
               onAddMediaTag={this.onAddMediaTag.bind(this)} 
               onFileQuery={this.onFileQuery.bind(this)} 
               onFileDelete={this.onFileDelete.bind(this)}
               onFilesSelected={this.onFilesSelected.bind(this)} 
               queryStringWidth={this.queryStringWidth} 
               AsideComponent={this.props.AsideComponent} 
               asideProps={this.props.asideProps}
             />
         );
     }
}

export default{
    MediaManagerFileType,
    MediaManagerToolbar,
    MediaManagerAsideImage,
    MediaManagerAsideSvg,
    MediaManagerAsideCard,
    MediaManagerAsideScrollable,
    MediaManagerAside,
    MediaManagerFooter,
    MediaManagerMainHeader,
    MediaManagerFile,
    MediaManagerLibrary,
    MediaManagerAdded,
    MediaManagerSelected,
    MediaManagerUpload,
    MediaManagerTags,
    MediaManager,
    MediaManagerController
}